export default "__VITE_PUBLIC_ASSET__672517de__"